import { CSSProperties } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useMapSearchItemStyles = makeStyles(({ spacing, palette }) => {
  const sharedStyle = {
    font: 'inherit',
    margin: 0,
    padding: 0,
  };
  const textOverflowStyle: CSSProperties = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  };
  return createStyles({
    textWrapper: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      ...sharedStyle,
    },
    textItem: {
      ...sharedStyle,
      ...textOverflowStyle,
    },
    boldText: {
      fontWeight: 'bold',
    },
    wholeTextItem: {
      ...sharedStyle,
      width: '100%',
      ...textOverflowStyle,
    },
    listItem: {
      width: '100%',
    },
    listItemIcon: {
      minWidth: spacing(5),
      padding: `0 ${spacing(3)} 0 ${spacing()}`,
    },
    deleteIconItem: {
      marginLeft: spacing(6),
      color: palette.grey.A200,
      height: spacing(5),
      '& svg': {
        fontSize: spacing(4),
      },
    },
    itemIcon: {
      color: palette.grey.A200,
      height: spacing(5),
      '& svg': {
        fontSize: spacing(5),
      },
      '& img': {
        height: spacing(4.5),
      },
    },
    listItemButton: {
      width: '100%',
      padding: spacing(),
    },
    newWindowIconItem: {
      color: palette.grey.A200,
      height: spacing(5),
      '& svg': {
        fontSize: spacing(5),
      },
      '& img': {
        height: spacing(4.5),
      },
    },
  });
});

export default useMapSearchItemStyles;
